// extracted by mini-css-extract-plugin
module.exports = {"container":"FM","productName":"GM","modal":"HM","dimensions":"IM","recipientEmail":"JM","lowStock":"KM","recommendedFit":"LM"};